import { StoryContainer } from './blocks/StoryContainer'
import { StoryHeader } from './blocks/StoryHeader'
import { StorySection } from './blocks/StorySection'
import { StoryMeta } from './blocks/StoryMeta'
import { StoryArticle } from 'modules/Feed/components/StoryArticle/StoryArticle'
import { StoryTags } from './blocks/StoryTags'
import { StoryBody } from './blocks/StoryBody'
import { FeedGallery } from 'modules/Feed/components/FeedGallery/FeedGallery'
import { StoryComments } from './blocks/StoryComments'
import { StoryDivider } from './blocks/StoryDivider'
import { SharedBookmark } from './blocks/SharedBookmark'
import { ZoneBadge } from './blocks/ZoneBadge'


export type { TStory } from './types'

export const Story = {
  Container: StoryContainer,
  Header: StoryHeader,
  Section: StorySection,
  Article: StoryArticle,
  Gallery: FeedGallery,
  Body: StoryBody,
  Meta: StoryMeta,
  Tags: StoryTags,
  Comments: StoryComments,
  Divider: StoryDivider,
  SharedBookmark: SharedBookmark,
  ZoneBadge: ZoneBadge
}
